import { SVG, SVGProps } from './svg'

export function IconChartBar(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M13 4h-2a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1Zm-5 9v6c0 .6-.4 1-1 1H5a1 1 0 0 1-1-1v-6c0-.6.4-1 1-1h2c.6 0 1 .4 1 1Zm9-5h2c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1h-2a1 1 0 0 1-1-1V9c0-.6.4-1 1-1Z" />
    </SVG>
  )
}
